import React from 'react';
import { Button as MUIButton, styled } from '@mui/material';

type ButtonProps = {
  text?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  buttonStyles?: React.CSSProperties;
};

const StyledButton = styled(MUIButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  padding: '0.75rem 1.5rem',
  fontSize: '1rem',
  fontWeight: 600,
  color: 'var(--brand-cobalt)',
  backgroundColor: 'var(--white)',
  borderRadius: 'var(--r-md)',
  transition: 'background-color 0.3s, transform 0.2s',
  textTransform: 'none',
  boxShadow: 'none',
  border: '2px solid var(--brand-cobalt)',

  '&:hover': {
    backgroundColor: 'var(--white)',
    color: 'var(--brand-cobalt)',
    boxShadow: 'none',
  },
  '&:active': {
    transform: 'scale(0.95)',
  },
  '&.Mui-disabled': {
    backgroundColor: 'var(--white)',
    color: 'var(--brand-cobalt)',
    opacity: 0.6,
    cursor: 'not-allowed',
  },

  [theme.breakpoints.down('md')]: {
    padding: '0.5rem 1rem',
    fontSize: '0.9rem',
  },
}));

const Button: React.FC<ButtonProps> = ({
  text,
  icon,
  onClick,
  disabled = false,
  className,
  buttonStyles = {},
}) => {
  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={buttonStyles}
      startIcon={icon}
    >
      {text}
    </StyledButton>
  );
};

export default Button;
